import Client from "../../api/client";
import {CURRENCIES_FALLBACK} from "./currencies-fallback.constants";

const CURRENCY_LIST_PATH = "frontend/currency/list";

export let locales = {
    de: {
        "decimal":   ",",
        "thousands": ".",
        "grouping":  [3],
        "currency":  ["", "SYMBOL"]
    },
    en: {
        "decimal": ".",
        "thousands": ",",
        "grouping": [3],
        "currency": ["SYMBOL", ""]
    }
};

function cloneFallbackMap() {
    return {...CURRENCIES_FALLBACK};
}

export let currencies = cloneFallbackMap();

export async function loadCurrenciesFromApi(apiClient) {
    try {
        const client = apiClient ?? Client.getInstance();
        const currencyMap = await client.get(CURRENCY_LIST_PATH);
        if (currencyMap && Object.keys(currencyMap).length) {
            currencies = currencyMap;
        }
    } catch (e) {
    }
}
